var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ProjectProposalLifecycleSetter", {
        attrs: { viewModel: _vm.projectProposalLifecycleSetter },
        on: { confirm: _vm.handleProposed },
      }),
      _vm._v(" "),
      _c("ProjectQualifiedLifecycleSetter", {
        attrs: { viewModel: _vm.projectQualifiedLifecycleSetter },
        on: { confirm: _vm.handleQualified },
      }),
      _vm._v(" "),
      _c("ProjectRejectedLifecycleSetter", {
        attrs: { viewModel: _vm.projectRejectedLifecycleSetter },
        on: { confirm: _vm.handleRejected },
      }),
      _vm._v(" "),
      _c("ProjectScheduledLifecycleSetter", {
        attrs: { viewModel: _vm.projectScheduledLifecycleSetter },
        on: { confirm: _vm.handleScheduled },
      }),
      _vm._v(" "),
      _c("ProjectInProgressLifecycleSetter", {
        attrs: { viewModel: _vm.projectInProgressLifecycleSetter },
        on: { confirm: _vm.handleStarted },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid",
          staticStyle: { "margin-top": "80px", "padding-top": "20px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c("h6", { staticClass: "text-muted mt-2" }, [
                _vm._v(_vm._s(_vm.portfolioName)),
              ]),
              _vm._v(" "),
              _c(
                "h1",
                {
                  staticStyle: {
                    "font-size": "2em",
                    "font-weight": "300",
                    color: "#33475b",
                    margin: "0",
                  },
                },
                [_vm._v("Scheduled projects")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right align-self-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: { click: _vm.handleSaveViewSettings },
                },
                [_vm._v("Save")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "toolbar" }, [
            _c("div"),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.handleShowGridColumnsEditor },
                },
                [_vm._v("Edit columns")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn-group" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary dropdown-toggle",
                    attrs: { type: "button", "data-toggle": "dropdown" },
                  },
                  [
                    _vm._v(
                      "\n                        Actions\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-menu dropdown-menu-right" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: { click: _vm.handleClearGridFilters },
                      },
                      [_vm._v("Clear Filters")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: { type: "button", title: "Download to spreadsheet" },
                  on: { click: _vm.handleExportGrid },
                },
                [_c("i", { staticClass: "fa fa-download fa-lg" })]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("ProjectsGrid", { attrs: { viewModel: _vm.grid } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }